import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  height?: number
  width?: number
  fill?: string
}

Play.defaultProps = {
  cover: `#ffffff`,
}

function Play(props: Props) {
  return (
    <div
      className={cx(
        "bg-white-50",
        "flex",
        "flex-col",
        "justify-center",
        "rounded-full",
        props.className
      )}
    >
      <svg
        className="mx-auto"
        height={20}
        width={17}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17 20"
      >
        <path
          d="M0.634766 1.70686V18.087C0.634766 19.3349 2.0123 20.0909 3.06562 19.4219L15.9347 11.2326C16.9121 10.611 16.9121 9.18604 15.9347 8.56449L3.06562 0.372026C2.0123 -0.298554 0.634766 0.459011 0.634766 1.70686Z"
          fill={props.fill}
        />
      </svg>
    </div>
  )
}

export default Play
